import React, { FunctionComponent, useContext } from 'react';
import {
  SingleRaceRecord,
  IppodromItem,
} from '/src/domain/challenges/ChallengeProtocolData';
import { ChallengeContext, ChallengeContextProps } from "/src/contexts/ChallengeContext";
import { ClubLogo, ClubLogoSize } from '../../shared/ClubLogo';
import { Grid, Box, SxProps, Tooltip, Link } from '@mui/material';
import { theme as themeColor } from '/src/assets/theme';
import { useTranslation } from 'react-i18next';
import { links } from '/src/domain/shared/links';

export interface ClubRecordProps {
  id: string;
  clubKey?: string;
  name: string;
  logoUrl?: string;
  records: (SingleRaceRecord | IppodromItem)[];
  averagePlace: number;
  place: number;
  protocolsContainerRef: React.RefObject<HTMLDivElement>;
}

const SCROLL_TIMEOUT_MS = 1000;

export const ClubRecord: FunctionComponent<ClubRecordProps> = ({
  id,
  clubKey,
  name,
  logoUrl,
  records,
  averagePlace,
  place,
  protocolsContainerRef,
}) => {
  const { t } = useTranslation();
  const { changeChosenClub } = useContext(ChallengeContext) as ChallengeContextProps;
  const clubLink = clubKey ? `${links.origin}/club?id=${clubKey}` : undefined;

  const handleClickAveragePlace = (clubId: string) => {
    changeChosenClub(clubId);
    setTimeout(() => {
      protocolsContainerRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, SCROLL_TIMEOUT_MS);
    
  }

  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      sx={{
        padding: '0.5rem',
        '&:nth-child(even)': {
          backgroundColor: themeColor.lightPrimaryColor,
        },
      }}
    >
      <Grid item xs={2} container style={{ paddingLeft: 0 }} sx={sxCell}>
        {place}
      </Grid>
      <Grid
        item
        xs={4}
        container
        component={Link}
        href={clubLink}
        underline={clubKey ? 'hover' : 'none'}
        sx={sxCell}
      >
        {name}
      </Grid>
      <Grid item xs={3} container component={Link} href={clubLink} sx={sxCell}>
        <ClubLogo size={ClubLogoSize.SMALL} url={logoUrl} />
      </Grid>
      <Grid
        item
        xs={2}
        container
        component={Link}
        underline={'hover'}
        onClick={() => handleClickAveragePlace(String(id))}
        sx={{
          ...sxCell,
          justifyContent: 'flex-end',
          cursor: 'pointer',
        }}
      >
        <Tooltip title={averagePlace} arrow enterTouchDelay={0}>
          <Box>{Math.round(averagePlace)}</Box>
        </Tooltip>
      </Grid>
    </Grid>
  );
};

const sxCell: SxProps = {
  display: 'flex',
  alignItems: 'center',
};
